<template>
  <div class="user-info__summary">
    <p v-html="userInfoSummary"></p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DomainList',
  computed: {
    ...mapState([
      'userData',
      'planData'
    ]),
    userInfoSummary () {
      const planData = this.planData
      let summary
      let planName = planData.planName

      if (planData.isTrialOver || planData.isTerminated) {
        planName = null
      }

      if (planName) {
        summary = this.$t('dashboard.userInfoSummary.usingPlan', {
          userName: this.userData.userId,
          planName: planName
        })
      } else {
        summary = this.$t('dashboard.userInfoSummary.usingNoPlan', {
          userName: this.userData.userId
        })
      }
      return summary
    }
  }
}
</script>

<style lang="scss">
.user-info__summary {
  p {
    font-size: 13px;
    color: #444444;
    padding-left: 10px;
    font-weight: 500;
    .user-name {
      font-size: 14px;
      font-weight: 400;
    }
    .plan-name {
      color: $brandColor;
    }
  }
}
</style>
